const UserPermissionLevels = {
    SYSTEM: 'system',
    BRAND: 'brand',
    CHAIN: 'chain',
    HOTEL: 'hotel'
};
export default UserPermissionLevels;



// WEBPACK FOOTER //
// ./src/constants/UserPermissionLevels.js